<template>
  <v-main>
    <v-container>
      <v-card elevation="6">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Update Module
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                ref="project"
                v-model="form.project_id"
                :items="projectItems"
                label="Select Project"
                prepend-inner-icon="mdi-ferry"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Name *"
                prepend-inner-icon="mdi-ship-wheel"
                :error-messages="errors.name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.workshop_name"
                outlined
                label="Workshop Name"
                prepend-inner-icon="mdi-shipping-pallet"
                :error-messages="errors.workshop_name"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.qty"
                outlined
                label="Qty *"
                prepend-inner-icon="mdi-sort-numeric-variant"
                :error-messages="errors.qty"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.dry_dock"
                outlined
                label="Dry Dock"
                prepend-inner-icon="mdi-docker"
                :error-messages="errors.dry_dock"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.estimate_cost"
                outlined
                label="Estimate Cost"
                prepend-inner-icon="mdi-cash-multiple"
                :error-messages="errors.estimate_cost"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.actual_cost"
                outlined
                label="Actual Cost"
                prepend-inner-icon="mdi-cash-multiple"
                :error-messages="errors.actual_cost"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.remark"
                outlined
                label="Remark"
                prepend-inner-icon="mdi-comment-text"
                :error-messages="errors.remark"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-progress-circular
            v-if="isLoading"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-btn v-else color="primary" dark @click="save">
            Update Module
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "ModuleEditPage",
  data() {
    return {
      form: {
        name: "",
        project_id: "",
        workshop_name: "",
        qty: "",
        dry_dock: "",
        estimate_cost: "",
        actual_cost: "",
        remark: "",
      },
      projectItems: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("modules/masters");
      masters = masters.data;
      masters.projects.forEach((project) => {
        this.projectItems.push({
          id: project.id,
          text: project.name,
          value: project.id,
        });
      });
    },
    async getData() {
      this.isLoading = true;
      let form = await axios.get(`/modules/${this.$route.params.moduleId}`);
      this.form = form.data.data;
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post(`/modules`, this.form);
        this.isLoading = false;
        this.$router.push("/modules");
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
